import { DefaultLoader } from '@euler/app/components/loaders/DefaultLoader';
import { ReworkRecordContext } from '@euler/app/flows/task/pages/delivery-check/rework-record/Provider';
import { ReworkRecordFlowNavigator } from '@euler/app/flows/task/pages/delivery-check/rework-record/ReworkRecordFlowNavigator';
import { useGeneralBottomSheetModal } from '@euler/functions/useBottomSheetModal';
import { ReworkRecordStaged } from '@euler/model/task-detail/ReworkRecord';
import { usePersistFn } from '@euler/utils/hooks';
import {
  BottomSheetFooter,
  BottomSheetFooterProps,
  BottomSheetModal,
} from '@gorhom/bottom-sheet';
import { FC, Suspense, memo } from 'react';
import { ScrollView } from 'react-native';
import { Slot } from 'react-slot-fill';

const kFooterSlotName = 'rework-record-footer';

export const ReworkRecordBottomSheet = memo(
  ({
    show,
    recordInfo,
    onDone,
    onDismiss,
  }: {
    show?: boolean;
    recordInfo?: ReworkRecordStaged;
    onDone?: (record: ReworkRecordStaged) => void;
    onDismiss?: () => void;
  }) => {
    const { bottomSheetModalRef, ...bottomSheetProps } =
      useGeneralBottomSheetModal({
        show,
        minSnapPoint: '50%',
        mediumSnapPoint: '70%',
        onDismiss,
        dismissWhenPressBackdrop: false,
        enablePanDownToClose: false,
      });

    const onKeywordInputFocus = usePersistFn(() => {
      const n = (bottomSheetProps.snapPoints as any[]).length;
      bottomSheetModalRef.current?.snapToIndex(n - 1);
    });

    return (
      <BottomSheetModal
        ref={bottomSheetModalRef}
        footerComponent={Footer}
        {...bottomSheetProps}
      >
        <Suspense
          fallback={
            <ScrollView
              contentContainerStyle={{
                flexGrow: 1,
                alignItems: 'center',
              }}
            >
              <DefaultLoader />
            </ScrollView>
          }
        >
          {recordInfo != null && (
            <ReworkRecordContext.Provider
              value={{ footerSlotName: kFooterSlotName }}
            >
              <ReworkRecordFlowNavigator
                recordInfo={recordInfo}
                onDone={onDone}
                onKeywordInputFocus={onKeywordInputFocus}
                onCancel={onDismiss}
              />
            </ReworkRecordContext.Provider>
          )}
        </Suspense>
      </BottomSheetModal>
    );
  },
);

const Footer: FC<BottomSheetFooterProps> = memo(props => {
  return (
    <BottomSheetFooter {...props} bottomInset={0}>
      <Slot name={kFooterSlotName} />
    </BottomSheetFooter>
  );
});
